import { isFinite } from 'lodash';
import * as d3Array from 'd3-array';

const BINS_NUMBER = 5;

export function titleOptions(name) {
  return {
    title: {
      text: name,
      textStyle: {
        fontWeight: 'lighter',
        fontSize: 14,
      },
      left: 'center',
    },
  };
}

export const GreyColors = {
  color: '#c7c7c7',
  highlight: '#343435',
  lineStyle: {
    color: '#a7acb1',
  },
  axisLine: {
    lineStyle: {
      color: '#a7acb1',
    },
  },
  axisLabel: {
    color: '#6c757d',
  },
  splitLine: {
    lineStyle: {
      color: '#F3F3F3',
    },
  },
};

export const tooltipOptions = {
  padding: 0,
  hideDelay: 0,
  transitionDuration: 0,
  backgroundColor: 'rgba(0,0,0,0)',
};

export const teamColors = {
  visitorColor: '#F6B852',
  homeColor: '#5C91CC',
};

export function decimalMinutesToFormattedTime(decimalMinutes) {
  const minutes = Math.floor(decimalMinutes);
  let seconds = Math.floor((decimalMinutes - minutes) * 60);
  seconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${minutes}:${seconds}`;
}

export function toFixedDecimalString(value) {
  return isFinite(value) ? Math.round(value * 100) / 100 : '-';
}

export function getBins(seriesData, binsNumber = BINS_NUMBER) {
  if (!seriesData || !seriesData.length) return [];

  return d3Array.histogram().thresholds(binsNumber)(seriesData);
}

export function generatePlayerKey(player) {
  const tokens = player.normalized.split(' ');
  const initials = tokens
    .map(token => token && token[0])
    .join('')
    .toUpperCase();
  return `${initials}\n${player.jersey}`;
}
